
const digest = 'f862ccd1187d2f5a5a977ff74414f6be32f8ce27ab6fa140be82d7e2fde67858';
const css = `._codeSnippet_1uny7_1 {
  font-family: monospace;
  color: #d14;
  border: 1px solid #e1e1e8;
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: #f7f7f9;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_1uny7_1"};
export { css, digest };
  